import type { ReactNode } from "react";

interface DisclosureProps {
  children: ReactNode;
  defaultOpen?: boolean;
  /** Anchor target, so an index can link straight to one item. */
  id?: string;
  summary: string;
}

/**
 * A native <details>. The +/− marker is drawn in CSS after the summary.
 *
 * Deliberately no `name` attribute: that would make the group exclusive, and
 * comparing two answers side by side is the point of the pages this appears on.
 * `open` is passed as the initial attribute only, so React writes it once and
 * the element stays uncontrolled — find-in-page can still expand it.
 */
export function Disclosure({
  children,
  defaultOpen = false,
  id,
  summary,
}: Readonly<DisclosureProps>) {
  return (
    <details className="disclosure" id={id} open={defaultOpen}>
      <summary>{summary}</summary>
      {children}
    </details>
  );
}
